import { FileSaveRequestInput, ISignAndStampFileBulk } from '../models/models';
import { client, gql } from './Client';

const saveSignAndStampMutation = gql`
  mutation userSignAndStampFileInfo($userFileRequest: MobileUserSignAndStampInfoInput) {
    userSignAndStampFileInfo(userFileRequest: $userFileRequest) {
      fileId
      uUID
      inspectionId
      result
    }
  }
`;

const bulkFISaveSignAndStampMutation = gql`
  mutation bulkFISaveSignAndStamp(
    $userFileRequest: MobileUserSignAndStampInfoInput
    $fileSaveRequest: [FileSaveRequestInput]
  ) {
    bulkFISaveSignAndStamp(userFileRequest: $userFileRequest, fileSaveRequest: $fileSaveRequest) {
      fileId
      uUID
      inspectionId
      result
    }
  }
`;

const bulkLISaveSignAndStampMutation = gql`
  mutation bulkLISaveSignAndStamp(
    $userFileRequest: MobileUserSignAndStampInfoInput
    $fileSaveRequest: [FileSaveRequestInput]
  ) {
    bulkLISaveSignAndStamp(userFileRequest: $userFileRequest, fileSaveRequest: $fileSaveRequest) {
      fileId
      uUID
      inspectionId
      result
    }
  }
`;

const saveSignAndStamp = (userFileRequest: ISignAndStampFileBulk) =>
  client.mutate({
    mutation: saveSignAndStampMutation,
    variables: {
      userFileRequest: {
        ...userFileRequest,
        isLiStamp:
          userFileRequest?.inspectionId?.length && userFileRequest?.fkAssetInspectionTask === 0
            ? true
            : false,
      },
    },
  });

const updateAdhocSignAndStampMutation = gql`
  mutation userSignAndStampFileInfo(
    $MobileUserSignAndStampInfoInput: MobileUserSignAndStampInfoInput
  ) {
    userSignAndStampFileInfo(userFileRequest: $MobileUserSignAndStampInfoInput) {
      fileId
      uUID
      inspectionId
      result
    }
  }
`;

const updateAdhocSignAndStamp = (MobileUserSignAndStampInfoInput: ISignAndStampFileBulk) =>
  client.mutate({
    mutation: updateAdhocSignAndStampMutation,
    variables: { MobileUserSignAndStampInfoInput },
  });

const saveBulkSignAndStamp = (variables: {
  userFileRequest: ISignAndStampFileBulk;
  fileSaveRequest: FileSaveRequestInput[];
}) =>
  client.mutate({
    mutation: variables?.userFileRequest?.isLiStamp
      ? bulkLISaveSignAndStampMutation
      : bulkFISaveSignAndStampMutation,
    variables,
  });

export { saveSignAndStamp, updateAdhocSignAndStamp, saveBulkSignAndStamp };
